/* eslint-disable indent */
import React, { Component } from "react";
import { Route } from "react-router-dom";
import { getCurrentUserFromLocalStorage } from "utils/common";
import { UserLevel } from "utils/constant";
import { Footer, Header, Sidebar } from "../../components";
import {
  CadreMonitoring,
  Dashboard,
  DistribusiKelambuNasional,
  PeCases,
  RegmalSecondComponent,
  User,
  UserVerification,
  VectorControllResultsReport,
} from "../../pages";

import DataDasarPenduduk from "pages/DataDasarPenduduk";
import DataEndemisitas from "pages/DataEndemisitas";
import CadrePerformance from "pages/DataKasus/CadreMonitoring/CadrePerformance";
import ExpiredStock from "pages/LogistikFaskes/ExpiredStock";
import InputStock from "pages/LogistikFaskes/InputStock";
import OffStock from "pages/LogistikFaskes/OffStock";
import RequestRecap from "pages/LogistikFaskes/RequestRecap";
import RequestStock from "pages/LogistikFaskes/RequestStock";
import FasyankesRequestFulfillment from "pages/LogistikKabupaten/FasyankesRequestFulfillment";
import KabupatenExpiredStock from "pages/LogistikKabupaten/KabupatenExpiredStock";
import KabupatenInputStock from "pages/LogistikKabupaten/KabupatenInputStock";
import KabupatenRequestRecap from "pages/LogistikKabupaten/KabupatenRequestRecap";
import KabupatenRequestStock from "pages/LogistikKabupaten/KabupatenRequestStock";
import KabupatenRequestFulfillment from "pages/LogistikProvinsi/KabupatenRequestFulfillment";
import ProvinsiExpiredStock from "pages/LogistikProvinsi/ProvinsiExpiredStock";
import ProvinsiInputStock from "pages/LogistikProvinsi/ProvinsiInputStock";
import ProvinsiRequestStock from "pages/LogistikProvinsi/ProvinsiRequestStock";
import ProvinsiRequestFulfillment from "pages/LogistikPusat/ProvinsiRequestFulfillment";
import ProvinsiRequestRecap from "pages/LogistikProvinsi/ProvinsiRequestRecap";
import ZeroReporting from "pages/DataKasus/ZeroReporting";
import DataDasarFaskesPage from "pages/DataDasarFaskes";
import IndigenousValidation from "pages/IndigenousValidation";
import IndigenousFeedback from "pages/IndigenousFeedback";
import UploadSyncForm from "pages/UploadSync";
import Pelapor from "pages/Repoter";
import IndigenousDetail from "pages/IndigenousValidation/components/Detail";
import MalariaScreening from "pages/DataKasus/MalariaScreening";
import AchievedData from "pages/DataKasus/MalariaScreening/AchievmentData";
import DataCapaianRumahSakit from "pages/DataKasus/DataCapaianRumahSakit";
import FlickIdentification from "pages/Vektor/FlickIdentification";
import LarvaBreedingIntervention from "pages/Vektor/FlickIdentification/LarvaBreedingIntervention";
import MoquitoIdentificationData from "pages/Vektor/MoquitoIdentificationData";
import IRSResultReport from "pages/Vektor/IRSResultReport";
import LaporanPage from "pages/Laporan";
import Mikroskopis from "pages/MikroskopisFaskes";
import CrosscheckerKabKota from "pages/CrosscheckerKabKota";
import CrosscheckerProvinsi from "pages/CrosscheckerProvinsi";
import DataLab from "pages/DataDasarLab";
import KetenagaanPuskesmas from "pages/Ketenagaan/puskesmas";

// Page Analisis
import AnalisisPage from "pages/Analisis";
import DataPenduduk from "pages/DataPenduduk";
import DetailLaporan from "pages/Laporan/components/DetailLaporan";
import MMP from "pages/MMP";
import CadreMMPPerformance from "pages/MMP/CadreMMP/CadrePerformance";

import RegisterMalaria1 from "pages/DataKasus/RegisterMalaria1";
import DetailRegmal1 from "pages/DataKasus/RegisterMalaria1/components/Detail";
import RegisterMalaria1Rujukan from "pages/DataKasus/RegisterMalaria1Rujukan";
import DetailRujukanPage from "pages/DataKasus/RegisterMalaria1Rujukan/DetailRujukanPage";
import NotifikasiKasusImpor from "pages/NotifikasiKasusImpor";
import NotifikasiKasusImporDetail from "pages/NotifikasiKasusImpor/components/DetailComponent";
import NotifikasiPEFeedback from "pages/DataKasus/NotifikasiPEFeedback";

// Uji Silang
import UjiSilangFaskes from "pages/UjiSilang/Faskes";
import UjiSilangFaskesSlidePositif from "pages/UjiSilang/Faskes/SlidePositif";
import UjiSilangFaskesSlideNegatif from "pages/UjiSilang/Faskes/SlideNegatif";

import UjiSilangKabKota from "pages/UjiSilang/KabKota";
import UjiSilangKabKotaVerifPositif from "pages/UjiSilang/KabKota/VerifPositif";
import UjiSilangKabKotaVerifNegatif from "pages/UjiSilang/KabKota/VerifNegatif";
import UjiSilangKabKotaSlidePositif from "pages/UjiSilang/KabKota/SlidePositif";
import UjiSilangKabKotaSlideNegatif from "pages/UjiSilang/KabKota/SlideNegatif";

import UjiSilangProvVerifPositif from "pages/UjiSilang/Prov/VerifPositif";
import UjiSilangProvVerifNegatif from "pages/UjiSilang/Prov/VerifNegatif";
import UjiSilangProvSlidePositif from "pages/UjiSilang/Prov/SlidePositif";
import UjiSilangProvSlideNegatif from "pages/UjiSilang/Prov/SlideNegatif";

import UjiSilang from "pages/Laporan/UjiSilang";
import UjiSilangIndividu from "pages/Laporan/UjiSilang/Individu";
import VerifikasiUjiSilang from "pages/Laporan/UjiSilangVerifikasi";
import RekapUjiSilang from "pages/Laporan/UjiSilangRekap";

// laporan BKK
import LaporanZeroReportBKK from "pages/Laporan/ZeroReportBKK";
import LaporanBasicDataBKK from "pages/Laporan/BasicDataBKK";
import LaporanBasicDataBKKInduk from "pages/Laporan/BasicDataBKKInduk";
import LaporanDataDasarLabBKK from "pages/Laporan/DataDasarLabBKK";
import LaporanMikroskopisBKK from "pages/Laporan/MikroskopisBKK";

// Page Laporan
import LZeroReport from "pages/Laporan/ZeroReport";
import LRegmal1 from "pages/Laporan/Regmal1";
import LRegmal1WNA from "pages/Laporan/Regmal1WNA";
import LRegmal1DesaDomisili from "pages/Laporan/Regmal1DesaDomisili";
import LRegmal2 from "pages/Laporan/Regmal2";
import LRekapRegmal2 from "pages/Laporan/RekapRegmal2";
import LMalariaKIA from "pages/Laporan/MalariaKIA";
import LTarikData1 from "pages/Laporan/TarikData1";
import LTarikData1Public from "pages/Laporan/TarikData1Public";
import LTarikData1Private from "pages/Laporan/TarikData1Private";
import LogistikStok from "pages/Laporan/LogistikStok";
import LKasusPE from "pages/Laporan/KasusPE";
import LRegmal2Public from "pages/Laporan/Regmal2Public";
import LRegmal2Private from "pages/Laporan/Regmal2Private";
import LRegmalRujukan from "pages/Laporan/RegmalRujukan";
import LBKKRegmalRujukan from "pages/Laporan/BKKRegmalRujukan";
import LogistikPemakaian from "pages/Laporan/LogistikPemakaian";
import LDataReseptifitas from "pages/Laporan/DataReseptifitas";
import LLogistikStok from "pages/Laporan/LogistikStok";
import LLogistikStokOut from "pages/Laporan/LogistikStokOut";
import LLogistikED from "pages/Laporan/LogistikStokED";
import LIdentifikasiJentik from "pages/Laporan/IdentifikasiJentik";
import LIdentifikasiNyamuk from "pages/Laporan/IdentifikasiNyamuk";
import LPengendalianVektor from "pages/Laporan/PengendalianVektor";
import LRekapPengendalianVektor from "pages/Laporan/RekapPengendalianVektor";
import LKelengkapanPublik from "pages/Laporan/KelengkapanPublik";
import LKelengkapanPrivate from "pages/Laporan/KelengkapanPrivate";
import LDataDanMonitoringKader from "pages/Laporan/DataDanMonitoringKader";
import LKinerjaKader from "pages/Laporan/KinerjaKader";
import LDataMMPDanaKinerjaKaderMMP from "pages/Laporan/MMPDanMonitoringKaderMMP";
import LaporanDataDasarPenduduk from "pages/Laporan/DataDasarPenduduk";
import LaporanKinerjaKaderMMP from "pages/Laporan/KinerjaKaderMMP";
import LaporanValidasiKasusIndigenous from "pages/Laporan/ValidasiKasusIndigenous";
import LaporanKelengkapanNasional from "pages/Laporan/KelengkapanNasional";
import InputSurveilansKnowlesi from "pages/InputSurveilansKnowlesi";
import RekapSurveilansKnowlesiFaskes from "pages/Laporan/RekapIndividuKnowlesiFasyankes";
import RekapAgregatSurveilansKnowlesiFasyankes from "pages/Laporan/RekapAgregatKnowlesiFasyankes";
import InputSurveilansKnowlesiLab from "pages/InputSurveilansKnowlesiLab";
import InputSurveilansKnowlesiLab5 from "pages/InputSurveilansKnowlesiLab5";
import RekapIndividuSurveilansKnowlesiLab from "pages/Laporan/RekapIndividuKnowlesiLab34";
import RekapIndividuSurveilansKnowlesiLab5 from "pages/Laporan/RekapIndividuKnowlesiLab5";
import RekapAgregatSurveilansKnowlesiLab5 from "pages/Laporan/RekapAgregatKnowlesiLab5";
import RekapAgregatSurveilansKnowlesiLab from "pages/Laporan/RekapAgregatKnowlesiLab34";
import LaporanMikroskopis from "pages/Laporan/MikroskopisFaskes";
import LaporanCrossCheckKab from "pages/Laporan/CrosscheckKab";
import LaporanCrossCheckProvinsi from "pages/Laporan/CrosscheckProvinsi";
import LaporanKetenagaan from "pages/Laporan/Ketenagaan";
import KetenagaanRsKlinik from "pages/Ketenagaan/RSKlinik";
import LaporanDataDasarlab from "pages/Laporan/DataDasarLab";
import LaporanRekapKelambu from "pages/Laporan/LaporanRekapKelambu";
import LaporanRekapIRS from "pages/Laporan/LaporanRekapIRS";
import LRekap1PemantauanJentik from "pages/Laporan/Rekap1PemantauanJentik";
import LRekap2PemantauanJentik from "pages/Laporan/Rekap2PemantauanJentik";
import LTren2PemantauanJentik from "pages/Laporan/Tren2PemantauanJentik";
import LRekapKohortLengkap from "pages/Laporan/RekapKohortLengkap";
import LRekapMaster from "pages/Laporan/RekapMaster";
import LaporanRekapMMP from "pages/Laporan/RekapMMP";
import LaporanPMEFasyankes from "pages/Laporan/LaporanPMEFasyankes";
import LaporanPMEBulanan from "pages/Laporan/LaporanPMEBulanan";
import LaporanPMETahunan from "pages/Laporan/LaporanPMETahunan";
import LaporanCadreRekapActive from "pages/Laporan/CadreRekapActive";
import LaporanCadreRekapActiveByLast3Month from "pages/Laporan/CadreRekapActiveByLast3Month";

// for bkk
import DataDasarBKK from "pages/BKK/DataDasarBKK";
import DataDasarBKKWilker from "pages/BKK/DataDasarBKKWilker";
import DataDasarBKKInduk from "pages/BKK/DataDasarBKKInduk";
import DataDasarBKKLab from "pages/BKK/DataDasarBKKLab";
import MikroskopisBKK from "pages/MikroskopisBKK";
import ZeroReportingBKK from "pages/BKK/ZeroReportingBKK";
import NotifikasiPeFeedback from "pages/BKK/NotifikasiPEFeedback";
import PeCasesBkk from "pages/DataKasus/PeCasesBkk";
import LaporanRegmal1Bkk from "pages/Laporan/BKKRegmal1";
import LaporanRegmal2BKK from "pages/Laporan/LaporanRegmal2BKK";
import AuditDeletedData from "pages/AuditDeletedData";
import MasterPengobatanStandar from "pages/MasterPengobatanStandar";
import MasterObat from "pages/MasterObat";
import MasterRegimen from "pages/StandardTreatment/MasterRegimen";
import MasterDoseBand from "pages/StandardTreatment/MasterDoseBand";
import StandardTreatmentVersions from "pages/StandardTreatment/Versions";
import StandardTreatmentRules from "pages/StandardTreatment/Rules";
import StandardTreatmentRuleDetail from "pages/StandardTreatment/RuleDetail";
import RegionalProvinsi from "pages/RegionalProvinsi";

class MainApp extends Component {
  render() {
    const currentUser = getCurrentUserFromLocalStorage();

    return (
      <div className="wrapper">
        <Header />
        <Sidebar />
        <div
          className="main-panel"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <div
            className="container"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="page-inner"
              style={{
                padding: "16px",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {![UserLevel.SR, UserLevel.SSR].includes(currentUser.level) && (
                <>
                  <Route path="/" component={Dashboard} exact />
                </>
              )}
              <Route path="/analisis" component={AnalisisPage} />

              <Route
                path="/detail-register-malaria-1-from-lpkl34/:id"
                component={DetailRegmal1}
              />
              <Route
                path="/detail-register-malaria-1-bkk/:id"
                component={DetailRegmal1}
              />
              <Route
                path="/detail-register-malaria-1/:id"
                component={DetailRegmal1}
              />

              {currentUser && currentUser.role !== "Viewer" && (
                <>
                  <Route path="/laporan" component={LaporanPage} exact />
                  <Route
                    path="/laporan/detail/:module"
                    component={DetailLaporan}
                  />

                  <Route
                    path="/laporan/ketenagaan"
                    component={LaporanKetenagaan}
                  />
                  <Route
                    path="/laporan/data-dasar-lab"
                    component={LaporanDataDasarlab}
                  />
                  <Route
                    path="/laporan/mikroskopis"
                    component={LaporanMikroskopis}
                  />
                  <Route
                    path="/laporan/crosscheck-kab"
                    component={LaporanCrossCheckKab}
                  />
                  <Route
                    path="/laporan/crosscheck-provinsi"
                    component={LaporanCrossCheckProvinsi}
                  />
                  <Route path="/laporan/uji-silang" component={UjiSilang} />
                  <Route
                    path="/laporan/uji-silang-individu"
                    component={UjiSilangIndividu}
                  />
                  <Route
                    path="/laporan/verifikasi-uji-silang"
                    component={VerifikasiUjiSilang}
                  />
                  <Route
                    path="/laporan/rekap-uji-silang"
                    component={RekapUjiSilang}
                  />
                  <Route path="/laporan/zero-report" component={LZeroReport} />
                  <Route path="/laporan/regmal1" component={LRegmal1} />
                  <Route path="/laporan/regmal1-wna" component={LRegmal1WNA} />
                  <Route
                    path="/laporan/regmal1-desa-domisili"
                    component={LRegmal1DesaDomisili}
                  />
                  <Route path="/laporan/regmal2" component={LRegmal2} />
                  <Route
                    path="/laporan/rekap-regmal2"
                    component={LRekapRegmal2}
                  />
                  <Route path="/laporan/malaria-kia" component={LMalariaKIA} />
                  <Route path="/laporan/tarik-data1" component={LTarikData1} />
                  <Route
                    path="/laporan/tarik-data1-publik"
                    component={LTarikData1Public}
                  />
                  <Route
                    path="/laporan/tarik-data1-private"
                    component={LTarikData1Private}
                  />
                  <Route
                    path="/laporan/logistik-pemakaian"
                    component={LogistikPemakaian}
                  />
                  <Route path="/laporan/kasus-pe" component={LKasusPE} />
                  <Route
                    path="/laporan/regmal2-public"
                    component={LRegmal2Public}
                  />
                  <Route
                    path="/laporan/regmal2-private"
                    component={LRegmal2Private}
                  />
                  <Route path="/laporan/rujukan" component={LRegmalRujukan} />
                  <Route
                    path="/laporan/rujukan-bkk"
                    component={LBKKRegmalRujukan}
                  />

                  {/* Laporan data reseptifitas */}
                  <Route
                    path="/laporan/reseptifitas"
                    component={LDataReseptifitas}
                  />

                  {/* Laporan logistik stok out */}
                  <Route
                    path="/laporan/logistik-stok-out"
                    component={LLogistikStokOut}
                  />
                  {/* Laporan logistik ED */}
                  <Route path="/laporan/logistik-ed" component={LLogistikED} />
                  <Route
                    path="/laporan/logistik-stok"
                    component={LLogistikStok}
                  />

                  {/* identifikasi jentik */}
                  <Route
                    path="/laporan/identifikasi-jentik"
                    component={LIdentifikasiJentik}
                  />

                  {/* identifikasi nyamuk */}
                  <Route
                    path="/laporan/identifikasi-nyamuk"
                    component={LIdentifikasiNyamuk}
                  />

                  {/* pengendalian vektor */}
                  <Route
                    path="/laporan/pengendalian-vektor"
                    component={LPengendalianVektor}
                  />

                  {/* rekap pengendalian vektor */}
                  <Route
                    path="/laporan/rekap-pengendalian-vektor"
                    component={LRekapPengendalianVektor}
                  />

                  {/* kelengkapan per bulan publik */}
                  <Route
                    path="/laporan/kelengkapan-perbulan-publik"
                    component={LKelengkapanPublik}
                  />
                  {/* kelengkapan per bulan private */}

                  <Route
                    path="/laporan/kelengkapan-perbulan-private"
                    component={LKelengkapanPrivate}
                  />

                  {/* kelengkapan laporan nasional */}
                  <Route
                    path="/laporan/kelengkapan-perbulan-nasional"
                    component={LaporanKelengkapanNasional}
                  />

                  {/* laporan data dan monitoring kader */}
                  <Route
                    path="/laporan/data-dan-monitoring-kader"
                    component={LDataDanMonitoringKader}
                  />
                  <Route
                    path="/laporan/cadre-rekap-active"
                    component={LaporanCadreRekapActive}
                  />
                  <Route
                    path="/laporan/cadre-rekap-active-by-last-3-month"
                    component={LaporanCadreRekapActiveByLast3Month}
                  />
                  <Route
                    path="/laporan/kinerja-kader"
                    component={LKinerjaKader}
                  />
                  <Route
                    path="/laporan/kinerja-kader-mmp"
                    component={LaporanKinerjaKaderMMP}
                  />
                  <Route
                    path="/laporan/mmp-dan-monitoring-kader-mmp"
                    component={LDataMMPDanaKinerjaKaderMMP}
                  />
                  <Route
                    path="/laporan/rekap-mmp"
                    component={LaporanRekapMMP}
                  />

                  <Route
                    path="/laporan/data-dasar-penduduk"
                    component={LaporanDataDasarPenduduk}
                  />

                  <Route
                    path="/laporan/validasi-kasus-indigenous"
                    component={LaporanValidasiKasusIndigenous}
                  />

                  <Route
                    path="/laporan/rekap-individu-data-surveilans-knowlesi-fasyankes"
                    component={RekapSurveilansKnowlesiFaskes}
                  />

                  <Route
                    path="/laporan/rekap-individu-data-surveilans-knowlesi-lab"
                    component={RekapIndividuSurveilansKnowlesiLab}
                  />

                  <Route
                    path="/laporan/rekap-individu-data-surveilans-knowlesi-lab-tier-5"
                    component={RekapIndividuSurveilansKnowlesiLab5}
                  />

                  <Route
                    path="/laporan/rekap-agregat-data-surveilans-knowlesi-lab-tier-5"
                    component={RekapAgregatSurveilansKnowlesiLab5}
                  />

                  <Route
                    path="/laporan/rekap-agregat-data-surveilans-knowlesi-lab"
                    component={RekapAgregatSurveilansKnowlesiLab}
                  />

                  <Route
                    path="/laporan/rekap-agregat-surveilans-knowlesi-fasyankes"
                    component={RekapAgregatSurveilansKnowlesiFasyankes}
                  />

                  <Route
                    path="/laporan/laporan-rekap-kelambu"
                    component={LaporanRekapKelambu}
                  />
                  <Route
                    path="/laporan/laporan-rekap-irs"
                    component={LaporanRekapIRS}
                  />
                  <Route
                    path="/laporan/rekap1-pemantauan-jentik"
                    component={LRekap1PemantauanJentik}
                  />
                  <Route
                    path="/laporan/rekap2-pemantauan-jentik"
                    component={LRekap2PemantauanJentik}
                  />
                  <Route
                    path="/laporan/tren2-pemantauan-jentik"
                    component={LTren2PemantauanJentik}
                  />
                  <Route
                    path="/laporan/rekap-kohort-lengkap"
                    component={LRekapKohortLengkap}
                  />
                  <Route
                    path="/laporan/rekap-master"
                    component={LRekapMaster}
                  />
                  <Route
                    path="/laporan/laporan-pme-fasyankes"
                    component={LaporanPMEFasyankes}
                  />
                  <Route
                    path="/laporan/laporan-pme-bulanan"
                    component={LaporanPMEBulanan}
                  />
                  <Route
                    path="/laporan/laporan-pme-tahunan"
                    component={LaporanPMETahunan}
                  />

                  <Route path="/data-penduduk" component={DataPenduduk} />

                  {currentUser &&
                    (currentUser.level === UserLevel.SR ||
                      currentUser.level === UserLevel.SSR) && (
                      <>
                        <Route
                          path="/monitoring-kader"
                          component={CadreMonitoring}
                        />
                        <Route
                          path="/kinerja-kader/:id"
                          component={CadrePerformance}
                        />
                      </>
                    )}

                  {currentUser && currentUser.level === UserLevel.Fasyankes && (
                    <>
                      {currentUser.fasyankes_type_id === "jnsfas-01" && (
                        <>
                          <Route path="/mmp" component={MMP} />
                          <Route
                            path="/cadre-mmp-performance/:id"
                            component={CadreMMPPerformance}
                          />
                          <Route path="/pe-kasus-bkk" component={PeCasesBkk} />
                          <Route path="/pe-kasus" component={PeCases} />
                          <Route
                            path="/monitoring-kader"
                            component={CadreMonitoring}
                          />
                          <Route
                            path="/kinerja-kader/:id"
                            component={CadrePerformance}
                          />
                          <Route
                            path="/skrining-malaria"
                            component={MalariaScreening}
                          />
                          <Route
                            path="/data-capaian/:id"
                            component={AchievedData}
                          />
                        </>
                      )}

                      <Route
                        path="/notifikasi-pe-feedback"
                        component={NotifikasiPEFeedback}
                      />

                      {currentUser.fasyankes_type_id !== "jnsfas-01" && (
                        <Route
                          path="/data-capaian"
                          component={DataCapaianRumahSakit}
                        />
                      )}

                      <Route
                        path="/logistik-input-stok"
                        component={InputStock}
                      />
                      <Route path="/logistik-putus-stok" component={OffStock} />
                      <Route
                        path="/logistik-expired-stok"
                        component={ExpiredStock}
                      />
                      <Route
                        path="/logistik-input-permintaan"
                        component={RequestStock}
                      />
                      <Route
                        path="/logistik-rekap-permintaan"
                        component={RequestRecap}
                      />
                      <Route
                        path="/data-dasar-penduduk"
                        component={DataDasarPenduduk}
                      />

                      <Route
                        path="/register-malaria-1"
                        component={RegisterMalaria1}
                      />
                      <Route
                        path="/regmal-dua"
                        component={RegmalSecondComponent}
                      />
                      <Route
                        path="/regmal-rujukan"
                        component={RegisterMalaria1Rujukan}
                      />
                      <Route
                        path="/bkk-regmal-rujukan"
                        component={RegisterMalaria1Rujukan}
                      />
                      {/* <Route path="/detail-rujukan/:id" component={DetailRegmal} /> */}
                      <Route
                        path="/detail-rujukan/:id"
                        component={DetailRujukanPage}
                      />
                      <Route
                        path="/detail-rujukan-bkk/:id"
                        component={DetailRujukanPage}
                      />
                      <Route path="/zero-report" component={ZeroReporting} />

                      {currentUser &&
                        currentUser.fasyankes_type_id === "jnsfas-01" && (
                          <>
                            <Route
                              path="/upload-sync"
                              component={UploadSyncForm}
                            />
                            <Route
                              path="/umpan-balik-indigenous"
                              component={IndigenousFeedback}
                            />
                          </>
                        )}

                      <Route path="/data-pelapor" component={Pelapor} />
                      <Route
                        path="/data-identifikasi-jentik"
                        component={FlickIdentification}
                      />
                      <Route
                        path="/data-intervensi-perindukan-nyamuk/:id"
                        component={LarvaBreedingIntervention}
                      />
                      <Route
                        path="/data-identifikasi-nyamuk"
                        component={MoquitoIdentificationData}
                      />
                      <Route
                        path="/laporan-pengendalian-vektor"
                        component={VectorControllResultsReport}
                      />
                      <Route
                        path="/uji-silang-faskes"
                        component={UjiSilangFaskes}
                        exact
                      />
                      <Route
                        path="/uji-silang-faskes/slide-positif"
                        component={UjiSilangFaskesSlidePositif}
                      />
                      <Route
                        path="/uji-silang-faskes/slide-negatif"
                        component={UjiSilangFaskesSlideNegatif}
                      />
                      <Route path="/mikroskopis" component={Mikroskopis} />
                      <Route path="/mikroskopis-data-lab" component={DataLab} />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.LabTier2 && (
                    <>
                      <Route
                        path="/uji-silang-kabkota/verif-slide-positif"
                        component={UjiSilangKabKotaVerifPositif}
                        exact
                      />
                      <Route
                        path="/uji-silang-kabkota/verif-slide-negatif"
                        component={UjiSilangKabKotaVerifNegatif}
                      />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.LabTier3 && (
                    <>
                      <Route
                        path="/uji-silang-prov/verif-slide-positif"
                        component={UjiSilangProvVerifPositif}
                        exact
                      />
                      <Route
                        path="/uji-silang-prov/verif-slide-negatif"
                        component={UjiSilangProvVerifNegatif}
                      />
                      <Route
                        path="/input-surveilans-knowlesi-lab"
                        component={InputSurveilansKnowlesiLab}
                      />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.LabTier4 && (
                    <>
                      <Route
                        path="/input-surveilans-knowlesi-lab"
                        component={InputSurveilansKnowlesiLab}
                      />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.LabTier5 && (
                    <>
                      <Route
                        path="/input-surveilans-knowlesi-lab5"
                        component={InputSurveilansKnowlesiLab5}
                      />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.District && (
                    <>
                      <Route
                        path="/data-dasar-faskes"
                        component={DataDasarFaskesPage}
                      />
                      <Route path="/data-pelapor" component={Pelapor} />
                      <Route
                        path="/input-surveilans-knowlesi"
                        component={InputSurveilansKnowlesi}
                      />
                      <Route
                        path="/validasi-indigenous"
                        component={IndigenousValidation}
                      />
                      <Route
                        path="/detail-indigenous/:id"
                        component={IndigenousDetail}
                      />
                      <Route
                        path="/logistik-kabupaten-input-stok"
                        component={KabupatenInputStock}
                      />
                      <Route
                        path="/logistik-kabupaten-expired-stok"
                        component={KabupatenExpiredStock}
                      />
                      <Route
                        path="/logistik-kabupaten-input-permintaan"
                        component={KabupatenRequestStock}
                      />
                      <Route
                        path="/logistik-kabupaten-rekap-permintaan"
                        component={KabupatenRequestRecap}
                      />
                      <Route
                        path="/logistik-pemenuhan-permintaan-faskes"
                        component={FasyankesRequestFulfillment}
                      />
                      <Route
                        path="/user-verification"
                        component={UserVerification}
                      />
                      <Route
                        path="/notifikasi-kasus-impor"
                        component={NotifikasiKasusImpor}
                      />
                      <Route
                        path="/notifikasi-kasus-impor-detail/:id"
                        component={NotifikasiKasusImporDetail}
                      />
                      <Route
                        path="/uji-silang-kabkota"
                        component={UjiSilangKabKota}
                        exact
                      />
                      <Route
                        path="/uji-silang-kabkota/slide-positif"
                        component={UjiSilangKabKotaSlidePositif}
                      />
                      <Route
                        path="/uji-silang-kabkota/slide-negatif"
                        component={UjiSilangKabKotaSlideNegatif}
                      />
                      <Route
                        path="/crosscheck-kabkota"
                        component={CrosscheckerKabKota}
                      />
                      <Route
                        path="/ketenagaan-puskesmas"
                        component={KetenagaanPuskesmas}
                      />
                      <Route
                        path="/ketenagaan-rs-klinik"
                        component={KetenagaanRsKlinik}
                      />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.Province && (
                    <>
                      <Route path="/data-pelapor" component={Pelapor} />
                      <Route
                        path="/logistik-provinsi-input-stok"
                        component={ProvinsiInputStock}
                      />
                      <Route
                        path="/logistik-provinsi-expired-stok"
                        component={ProvinsiExpiredStock}
                      />
                      <Route
                        path="/logistik-provinsi-input-permintaan"
                        component={ProvinsiRequestStock}
                      />
                      <Route
                        path="/logistik-provinsi-rekap-permintaan"
                        component={ProvinsiRequestRecap}
                      />
                      <Route
                        path="/logistik-pemenuhan-permintaan-kabupaten"
                        component={KabupatenRequestFulfillment}
                      />
                      <Route
                        path="/crosscheck-provinsi"
                        component={CrosscheckerProvinsi}
                      />
                      <Route
                        path="/uji-silang-prov/slide-positif"
                        component={UjiSilangProvSlidePositif}
                      />
                      <Route
                        path="/uji-silang-prov/slide-negatif"
                        component={UjiSilangProvSlideNegatif}
                      />
                    </>
                  )}

                  {currentUser && currentUser.level === UserLevel.National && (
                    <>
                      <Route
                        path="/data-dasar-penduduk"
                        component={DataDasarPenduduk}
                      />
                      <Route
                        path="/data-endemisitas"
                        component={DataEndemisitas}
                      />
                      <Route
                        path="/logistik-pemenuhan-permintaan-provinsi"
                        component={ProvinsiRequestFulfillment}
                      />
                      <Route
                        path="/distribusi-kelambu"
                        component={DistribusiKelambuNasional}
                      />
                      <Route path="/user" component={User} />
                      <Route
                        path="/user-verification"
                        component={UserVerification}
                      />
                      <Route
                        path="/audit-deleted-data"
                        component={AuditDeletedData}
                      />
                      <Route
                        path="/regional"
                        component={RegionalProvinsi}
                      />
                      <Route
                        path="/master-pengobatan-standar"
                        component={MasterPengobatanStandar}
                      />
                      <Route path="/obat" component={MasterObat} />
                      <Route path="/master-obat" component={MasterRegimen} />
                      <Route path="/dosis-standar" component={MasterDoseBand} />
                      <Route
                        path="/standard-treatment/versions"
                        component={StandardTreatmentVersions}
                      />
                      <Route
                        path="/standard-treatment/rules"
                        component={StandardTreatmentRules}
                        exact
                      />
                      <Route
                        path="/standard-treatment/rules/:id"
                        component={StandardTreatmentRuleDetail}
                      />
                    </>
                  )}
                </>
              )}

              {/* route bellow for bkk reporting */}
              {(currentUser.level === UserLevel.BKKInduk ||
                currentUser.level === UserLevel.BKKWilker ||
                currentUser.level === UserLevel.Province ||
                currentUser.level === UserLevel.District ||
                currentUser.level === UserLevel.National) && (
                <>
                  <Route
                    path="/laporan/laporan-zero-report-bkk"
                    component={LaporanZeroReportBKK}
                  />
                  <Route
                    path="/laporan/laporan-data-dasar-bkk-wilker"
                    component={LaporanBasicDataBKK}
                  />
                  <Route
                    path="/laporan/laporan-data-dasar-bkk-induk"
                    component={LaporanBasicDataBKKInduk}
                  />
                  <Route
                    path="/laporan/laporan-data-dasar-lab-bkk"
                    component={LaporanDataDasarLabBKK}
                  />
                  <Route
                    path="/laporan/laporan-mikroskopis-bkk"
                    component={LaporanMikroskopisBKK}
                  />
                  <Route
                    path="/laporan/laporan-regmal-1-bkk"
                    component={LaporanRegmal1Bkk}
                  />
                  <Route
                    path="/laporan/laporan-regmal-2-bkk"
                    component={LaporanRegmal2BKK}
                  />
                </>
              )}

              {/* BKK Access route */}
              <Route path="/data-dasar-bkk" component={DataDasarBKK} />
              <Route
                path="/data-dasar-bkk-wilker"
                component={DataDasarBKKWilker}
              />
              <Route
                path="/data-dasar-bkk-induk"
                component={DataDasarBKKInduk}
              />
              <Route
                path="/register-malaria-1-bkk"
                component={RegisterMalaria1}
              />
              <Route path="/regmal-dua-bkk" component={RegmalSecondComponent} />
              <Route path="/mikroskopis-bkk" component={MikroskopisBKK} />
              <Route path="/data-dasar-lab-bkk" component={DataDasarBKKLab} />
              <Route path="/zero-report-bkk" component={ZeroReportingBKK} />
              <Route
                path="/notifikasi-kasus-bkk"
                component={RegisterMalaria1}
              />
              <Route
                path="/notifikasi-pe-feedback-bkk"
                component={NotifikasiPeFeedback}
              />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default MainApp;
